import { ReactNode } from 'react';
import { MenuTopSkeleton } from '@components/layout/components/menu-top/menu-top-skeleton';
import { SidebarDesktopSkeleton } from '@components/sidebar-desktop/sidebar-desktop-skeleton';

export const DefaultLayoutShell = ({ children }: { children: ReactNode }) => (
  <div className='flex flex-col h-[calc(100dvh)] bg-secondary overflow-auto'>
    <MenuTopSkeleton />
    <div className='flex flex-row flex-1 overflow-hidden'>
      <div className='hidden lg:flex'>
        <SidebarDesktopSkeleton />
      </div>
      <main className='flex flex-col w-full overflow-hidden bg-secondary mx-auto'>{children}</main>
    </div>
  </div>
);
